import formatDate from 'date-fns/format';
import brLocale from 'date-fns/locale/pt';

const defaultFormat = 'DD/MM/YYYY, HH:mm:ss';

const formatedDate = (date, format = defaultFormat) => formatDate(date, format, {
  locale: brLocale,
});

export default formatedDate;



// WEBPACK FOOTER //
// ./src/services/date/index.js